import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../strings.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LoginPage29d8dob2fd0ln as LoginPage } from './LoginScreen.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HomePage3ptt6l367zajb as HomePage } from './HomeScreen.mjs';
import { get_currentSession2ignzypsmrqzv as get_currentSession } from '../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { ActivityIndicatork1oa7i2hevyv as ActivityIndicator } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ActivityIndicator.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { FullscreenPage2qcc83o0veqoh as FullscreenPage } from '../App.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function LandingPage$_get_title_$lambda_itu06o($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_landingPageTitle_9rfr0l_k$();
}
function LandingPage$render$slambda($this_render) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if (!((yield* await_0(get_currentSession(), $completion)) == null)) {
      get_pageNavigator($this_render.get_context_h02k06_k$()).reset_diztr_k$(new (HomePage())());
      tmp = Unit_instance;
    } else {
      get_pageNavigator($this_render.get_context_h02k06_k$()).reset_diztr_k$(new (LoginPage())());
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
var LandingPageClass;
function LandingPage() {
  if (LandingPageClass === VOID) {
    class $ {
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, LandingPage$_get_title_$lambda_itu06o);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        launch(_this__u8e3s4, VOID, VOID, LandingPage$render$slambda(_this__u8e3s4));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        // Inline function 'com.lightningkite.kiteui.views.direct.activityIndicator' call
        var this_0 = get_centered(element);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (ActivityIndicator())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_0.willAddChild_hz2iwc_k$(element_0);
        element_0.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_0);
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
    }
    initMetadataForClass($, 'LandingPage', LandingPage, VOID, [Page(), FullscreenPage()]);
    LandingPageClass = $;
  }
  return LandingPageClass;
}
//region block: exports
export {
  LandingPage as LandingPage17xvcovc6b4n0,
};
//endregion

//# sourceMappingURL=LandingScreen.mjs.map
